import React, { FC } from 'react';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { fetchRegularApplicationData, setApplicationDocuments } from '../../store/merchnts/actions/application';
import { useParams } from 'react-router-dom';
import { STATUSES } from '../../views/login/Login';
import { DocumentsUploaderPage } from './quick-application/DocumentsUploaderPage';

export const ApplicationDetailsDocuments: FC = () => {
  const { applicationId } = useParams<{ applicationId: string }>();

  const { merchantState, dispatch } = useMerchants();
  const { applicationData } = merchantState;

  return (
    <DocumentsUploaderPage
      showPlaceholder={false}
      id={applicationId}
      dataUploadedDocuments={applicationData?.uploadedDocuments}
      setDocuments={setApplicationDocuments}
      enableEditBlock={applicationData?.statusName !== STATUSES.CANCELLED && applicationData?.statusName !== STATUSES.DECLINED}
      onEditSuccess={async (): Promise<void> => await fetchRegularApplicationData({ dispatch, applicationId })}
      enableToDelete
    />
  );
};
